import { createGlobalStyle } from 'styled-components';
import { ThemeType } from 'assets/styles/theme';
import tw from 'tailwind.macro';

export default createGlobalStyle<{ theme: ThemeType }>`
  
`;
